export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_6-c29ff02025d15a5697546f297a2061d4.png";